import {MeasureUnitList} from './MeasureUnitList';

import SquareFootIcon from '@mui/icons-material/SquareFoot';
export default {
    list:MeasureUnitList,
    
    icon:SquareFootIcon
};